import { Injectable } from '@angular/core';
import { ClassState } from 'src/app/core/constants/class-state.enum';
import { ILookupService } from 'src/app/core/models/data-service/lookup-service.interface';
import { IClassState } from 'src/app/core/models/lookup-types/class-state.interface';
import { IGender } from 'src/app/core/models/lookup-types/gender.interface';

@Injectable({
  providedIn: 'root',
})
export class GenderLookupService implements ILookupService<IGender> {
  private genders: IGender[] = [
    { id: 'M', displayName: 'Male' },
    { id: 'F', displayName: 'Female' },
  ];

  loadItems(): void {}
  getAllItems(): IGender[] {
    return this.genders;
  }
  getItemById(id: number|string): IGender | undefined {
    return this.genders.find((gender) => gender.id === id);
  }
  getValue(key: string | number): string | number {
    return this.getItemById(key as number)?.displayName ?? '';
  }
  getDisplayName(data: IGender): string {
    return data.displayName;
  }
}
